import { getActionHistoryApi } from './configuration';

const actionHistory = {
  getActionHistory: () => {
    return getActionHistoryApi().readActionHistoryElements();
  },
};

export default actionHistory;
